import { useCallback, useEffect, useState } from "react";
import { Modal } from "../Modal";
import styles from "./KeyboardShortcutsModal.module.css";

const shortcuts = [
  { key: "M", action: "Toggle microphone mute" },
  { key: "V", action: "Toggle camera" },
  { key: "F", action: "Toggle fullscreen mode" },
  { key: "Space", action: "Push-to-talk (hold to talk)" },
  { key: "H", action: "Raise / lower hand" },
  { key: "1-5", action: "Send a reaction" },
  { key: "Esc", action: "Exit PiP / back" },
  { key: "?", action: "Show this help" },
];

export const KeyboardShortcutsModal = ({
  open,
  onDismiss,
}: {
  open: boolean;
  onDismiss: () => void;
}) => (
  <Modal title="Keyboard Shortcuts" open={open} onDismiss={onDismiss}>
    <div className={styles.content}>
      <table className={styles.table}>
        <tbody>
          {shortcuts.map(({ key, action }) => (
            <tr key={key}>
              <td className={styles.keyCell}>
                <kbd className={styles.kbd}>{key}</kbd>
              </td>
              <td className={styles.actionCell}>{action}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Modal>
);

export const useKeyboardShortcutsModal = () => {
  const [open, setOpen] = useState(false);
  const openModal = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => setOpen(false), []);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "?" && !e.altKey && !e.ctrlKey && !e.metaKey) {
        setOpen((prev) => !prev);
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  return { shortcutsOpen: open, openShortcuts: openModal, closeShortcuts: closeModal };
};
